module.exports = __webpack_public_path__ + "assets/round-checkmark.a380e049.svg";